<template>
  <b-container v-if="load.Loading" class="container-basic-spinner">
    <spinner />
  </b-container>

  <b-container v-else>
    <b-row>
      <h2>
        Внимание! <br>
        Нажмите на соответствующий пункт, если вы внесли в него изменения. <br>
        Это сбросит кэш и ваши изменения начнут появляться в мобильном приложении. <br>
        В веб-версии изменения появляются в новых аудитах сразу. Можете использовать это для проверки активностей.  
      </h2>  
    </b-row>

    <b-row>
      <button class="btn search-input-append-button btn-outline-success" @click="activitiesCache('1.0')">Активности v1 / Блоки вопросов v1 / Вопросы v1</button>
    </b-row> 

    <br>

    <b-row>
      <button class="btn search-input-append-button btn-outline-success" @click="activitiesCache('2.0')">Активности v2 / Блоки вопросов v2 / Вопросы v2</button>
    </b-row> 

    <br>

    <b-row>
      <button class="btn search-input-append-button btn-outline-success" @click="photoCache">Категории фото</button>
    </b-row>

     <br>

    <b-row>
      <button class="btn search-input-append-button btn-outline-success" @click="standardBooksCache">Книги стандартов</button>
    </b-row>

     <br>

    <b-row>
      <button class="btn search-input-append-button btn-outline-success" @click="todoCategoriesCache">Категории задач</button>
    </b-row>

  </b-container>
</template>

<script>
import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'
import ApiHeaders from '@/store/models/ApiHeaders'

export default {
    computed: {
        
    },
    data: function() {
      let load = new Loading();

      let apiHeaders = new ApiHeaders();

      return {
        load: load,
        apiHeaders: apiHeaders,
      }
    },

    methods: {
      activitiesCache: function (apiVersion) {
        this.load.Calculate(true);

            apiService.Admin.Cache.ResetActivities(this.apiHeaders.mapToDto(apiVersion))
                .then(() => {
                    this.load.Calculate(false);
                    dialogService.showAlert("Сброс активностей", "Активности успешно сброшены");
                })
                .catch(() => {
                  dialogService.showAlert("Возникла ошибка", "Обратитесь к администратору")
                  this.load.Calculate(false);
                });
      },

      photoCache: function() {
        this.load.Calculate(true);

            apiService.Admin.Cache.ResetPhotoCategories()
                .then(() => {
                    this.load.Calculate(false);
                    dialogService.showAlert("Сброс категорий фото", "Категории фото успешно сброшены");
                })
                .catch(() => {
                  dialogService.showAlert("Возникла ошибка", "Обратитесь к администратору")
                  this.load.Calculate(false);
                });
      },

      standardBooksCache: function() {
        this.load.Calculate(true);

            apiService.Admin.Cache.ResetStandartsBooks()
                .then(() => {
                    this.load.Calculate(false);
                    dialogService.showAlert("Сброс книг стандартов", "Книги стандартов успешно сброшены");
                })
                .catch(() => {
                  dialogService.showAlert("Возникла ошибка", "Обратитесь к администратору")
                  this.load.Calculate(false);
                });
      },

      todoCategoriesCache: function() {
        this.load.Calculate(true);

            apiService.Admin.Cache.ResetTodoCategories()
                .then(() => {
                    this.load.Calculate(false);
                    dialogService.showAlert("Сброс категорий задач ТТ", "Категории задач ТТ успешно сброшены");
                })
                .catch(() => {
                  dialogService.showAlert("Возникла ошибка", "Обратитесь к администратору")
                  this.load.Calculate(false);
                });
      },
    },
    components: {
      Spinner
    }
    
}
</script>

<style>

</style>